<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     线索报备弹框
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dialog ref="clueDialog" class="clue-report" width="600px" title="线索报备" :visible.sync="dialogShow" append-to-body :modal-append-to-body="false" :close-on-click-modal="false">
    <div v-if="step == 1">
      <el-alert type="warning" :closable="false">
        <div class="flex align-items-center">
          <div class="text-warning font-lg">
            <div class="iconfont icon-circle-warning"></div>
          </div>
          <div class="ml-xs">线索报备成功后，将获得平台保护。保护期内，其他合作伙伴无法报备同一线索</div>
        </div>
      </el-alert>
      <div class="mt-xs" style="width: 400px;margin: 80px auto 0;">
        <el-input v-model="keyword" placeholder="公司名称" @keyup.enter.native="handleSearch">
          <div slot="append" role="button" class="pl-lg pr-lg" @click="handleSearch"><i class="el-icon-search"></i></div>
        </el-input>
        <SearchContent ref="searchSelect" :keyword="keyword" tick @select="handleSelect" />
      </div>
      
    </div>

    <div v-if="step == 2">
      <el-form
        ref="clueForm"
        :model="clueForm"
        :rules="clueRules"
        label-position="left"
        label-width="120px"
        style=" margin: 10px 50px;">
        <el-form-item label="公司名称">
          <div>{{ clueCompany.name }}</div>
        </el-form-item>
        <el-form-item label="信用代码">
          <div>{{ clueCompany.creditCode }}</div>
        </el-form-item>
        <el-form-item label="意向等级" required>
          <el-radio-group v-model="clueForm.intention_level">
            <el-radio :label="3">高</el-radio>
            <el-radio :label="2">普通</el-radio>
            <el-radio :label="1">低</el-radio>
          </el-radio-group>
          <div class="font-sm text-muted">{{ clueForm.intention_level == 3 ? '高' : (clueForm.intention_level == 2 ? '普通' : '低') }}意向线索保护期为{{ clueForm.intention_level == 3 ? 6 : (clueForm.intention_level == 2 ? 3 : 1) }}个月</div>
        </el-form-item>
        <el-form-item label="沟通凭证" required>
          <f-image-card-uploader :files="clueForm.communication_evidence" :limit="5" aimPath="prm/" @change="onChange" />
        </el-form-item>
        <el-form-item label="线索描述" required>
          <el-input v-model="clueForm.description" type="textarea" :rows="5" placeholder="" />
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="text-center mb">
      <el-button v-if="step == 1" class="extend" plain @click="dialogShow = false">取消</el-button>
      <el-button v-if="step == 2" class="extend" plain @click="step = 1">上一步</el-button>
      <el-button v-if="step == 1" class="extend" type="primary" :disabled="!clueCompany.name" @click="verify">下一步</el-button>
      <el-button v-if="step == 2" class="extend" type="primary" @click="submit">提交</el-button>
    </div>
  </el-dialog>
</template>
  
<script>
import { companyCheckApi, leadCreateApi } from '@/api/prm/prmApi'

export default {
  name: "ClueReport",

  components: {
    FImageCardUploader: () => import('@/components/FImageCardUploader'),
    SearchContent: () => import('./SearchContent.vue'),
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },

    company: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      step: 1,
      keyword: "",
      is_exist: false,
      clueCompany: {},
      clueForm: {
        intention_level: 3,
        communication_evidence: [],
        description: "",
      },
      clueRules: {
        intention_level: [
          { required: true, message: "请选择意向等级", trigger: "change" },
        ],
        communication_evidence: [
          { required: true, message: "请上传沟通凭证", trigger: "change" },
        ],
        description: [
          { required: true, message: "请填写线索描述", trigger: "blur" },
        ],
      },
    };
  },

  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    }
  },

  watch: {
  },

  created() {
    this.clueCompany = Object.assign({}, this.company)
    if (this.clueCompany.company_id) {
      this.step = 2
    }
  },

  methods: {
    handleSearch() {
      this.$refs.searchSelect.handleSearch()
    },

    handleSelect(val) {
      this.keyword = val.name
      this.clueCompany = Object.assign({}, val)
    },

    onChange(files) {
      this.clueForm.communication_evidence = files
    },

    submit() {
      const temp = {
        company_id: this.clueCompany.company_id,
        intention_level: this.clueForm.intention_level,
        communication_evidence: this.clueForm.communication_evidence,
        description: this.clueForm.description,
      };
      this.$refs.clueForm.validate((valid) => {
        if (valid) {
          leadCreateApi(temp).then((res) => {
            if (!res.errno) {
              this.$message.success("线索报备成功！");
              this.$emit("success");
              this.dialogShow = false;
              this.$router.push('/prm/clue')
            } else {
              this.$message.error(res.message);
            }
          });
        }
      })
      
    },

    verify() {
      if (this.is_exist) return
      companyCheckApi({
        company_id: this.clueCompany.company_id
      }).then((res) => {
        if (!res.errno) {
          this.is_exist = res.data.is_exist
          if (res.data.is_exist) {
            this.$message.error({
              message: res.data.detail.is_self ? "你已报备过该公司" : "别人已报备过该公司",
              duration: 3000
            });
            setTimeout(() => {
              this.$emit("exist", this.clueCompany.company_id)
              this.dialogShow = false;
            }, 2500)
          } else {
            this.step = 2
          }
        } else {
          this.$message.error(res.message);
        }
      })
    }
  },
};
</script>
  
<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding: 10px 20px;
}
/deep/ .el-alert .el-alert__description {
  margin: 0 0 0 0;
}
/deep/ .el-input-group__append {
  padding: 0 0px;
  background-color: #07c160;
  border: 1px solid #07c160;
  color: #fff;
  line-height: 34px;
}
.clue-report {
  .box {
    height: 220px;
    padding: 0;
    .custom-option {
      padding: 15px 15px;
      cursor: pointer;
      border-bottom: 1px solid rgba(220,223,230,0.3);
      &:hover {
        background-color: #f5f4f6;
      }
    }
  }
}
</style>
  